import devConfig from 'appConfig.dev.json';
import prdConfig from 'appConfig.prd.json';

const envConfigs = {
    dev: devConfig,
    prd: prdConfig
}

const env = process.env.REACT_APP_BUILD_ENV ? process.env.REACT_APP_BUILD_ENV : 'dev';
const appConfigJson = envConfigs[env];

class AppConfig {
    constructor() {
        this.AzureADClientId = appConfigJson.AzureADClientId;
        this.AzureADAuthority = appConfigJson.AzureADAuthority;
        this.isProd = env === "prd"
    };
}

export default new AppConfig();